import React from 'react'
import CardElement from '../../components/card.v2'
import SelectorElement from '../../components/SelectElement'
import { useFormikContext } from 'formik'
import { useAvatar } from '../avatar/avatar.context'
import { ImageWrap, VideoWrap } from '../avatar/avatar'
import { HoverBorderGradientDemo } from '../../components/Button'

export const LayoutWithAvatar = ({ children }) => {
  return (
    <div className='max-w-6xl 2xl:max-w-full mx-auto flex justify-center items-center h-[calc(100vh-180px)] flex-col'>
      <div className='w-full grid grid-cols-2 justify-between -mt-36'>
        {children}
      </div>
    </div>
  )
}

export const AvatarPreview = () => {
  return (
    <div className=''>
      <VideoWrap />
      <ImageWrap />
    </div>
  )
}

const Gender = ({ currentStep, setCurrentStep }) => {
  const { values, setFieldValue } = useFormikContext()
  const { avatars } = useAvatar()

  const handleInputChange = (value) => {
    setFieldValue(`gender`, value) // Update userData dynamically
  }

  const filterByGender = (avatar) =>
    avatar.gender?.toLowerCase() === values.gender.toLowerCase()

  const verifyBgColor = (avatar) => avatar.need_remove_background

  const filteredAvatars = avatars.filter((avatar) => {
    return filterByGender(avatar) && verifyBgColor(avatar)
  })

  if (values.gender == 'Female') {
    filteredAvatars.unshift({
      pose_id: 'default',
      pose_name: 'Carla',
      normal_preview: '/images/default-removebg.png',
    })
  }

  return (
    <LayoutWithAvatar>
      <div className='flex col-span-2 max-w-sm mx-auto md:col-span-1 items-center gap-20 justify-center'>
        <CardElement fixHeight>
          <h2 className='text-gray-700 font-semibold mb-4 cursor-pointer'>
            <svg
              onClick={() => {
                setCurrentStep(currentStep - 1)
              }}
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              strokeWidth='2'
              stroke='currentColor'
              className='w-5 h-5'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M15 19l-7-7 7-7'
              />
            </svg>
          </h2>
          <h2 className='text-gray-700 font-semibold text-lg mb-4'>
            Please Select A Gender:
          </h2>
          <div className='flex flex-col gap-7 mt-6'>
            <SelectorElement
              label={'Male'}
              active={values.gender == 'Male'}
              onChange={handleInputChange}
            />
            <SelectorElement
              label={'Female'}
              active={values.gender == 'Female'}
              onChange={handleInputChange}
            />
          </div>
          {/* Button */}
          <div className='mt-8'>
            <HoverBorderGradientDemo
              type='button'
              onClick={() => {
                setCurrentStep(currentStep + 1)
              }}
              disabled={!values?.gender}
            >
              <span className='font-bold capitalize'>Select</span>
            </HoverBorderGradientDemo>
          </div>
        </CardElement>
      </div>

      <div className='col-span-1 hidden md:flex items-center justify-center px-8 relative  min-h-80'>
        <div>
          <video
            src={`/videos/1st-female.webm`}
            style={{
              filter: values.gender == 'Female' ? '' : 'hue-rotate(270deg)',
            }}
            autoPlay
            loop
            className='w-full h-full'
          />
        </div>
      </div>
    </LayoutWithAvatar>
  )
}

export default Gender
